module.exports = __webpack_public_path__ + "img/color-2.a374850.webp";